import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button,
    InputGroup, InputRightElement, Icon, VStack, Spacer, Divider, useToast
} from '@chakra-ui/react';
import { Form, Field } from 'react-final-form';
import {
    ViewIcon, ViewOffIcon
} from '@chakra-ui/icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css';

import axios from 'axios';
import { useCookies } from 'react-cookie';
import validator from "validator"

import { API_SUB_URL_USER, ERROR_CODES } from '../../../constants';
import { displayConfirmAlert } from '../../utils';
import Header from '../Header';
import Navbar from '../Navbar';

function ChangePassword() {
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
    const [isValidNewPassword, setIsValidNewPassword] = useState(false);

    const handleOldPasswordVisibility = () => setShowOldPassword(!showOldPassword);
    const handleNewPasswordVisibility = () => setShowNewPassword(!showNewPassword);
    const handleConfirmNewPasswordVisibility = () => setShowConfirmNewPassword(!showConfirmNewPassword);

    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    const navigate = useNavigate();
    const toast = useToast();

    const validate = (values) => {
        const errors = {};

        if(!values.currentPassword) {
            errors.currentPassword = "Required";
        }
        if(!values.newPassword) {
            errors.newPassword = "Required";
        }
        if(!values.confirmNewPassword) {
            errors.confirmNewPassword = "Required";
        }

        if(values.newPassword !== values.confirmNewPassword) {
            errors.newPasswordDifferentConfirmNewPassword = "Required";
        }

        if(values.newPassword) {
            const isStrongPassword = validator.isStrongPassword(values.newPassword, {minLength: 8, minLowercase: 1, minUppercase: 1, minSymbols: 0, minNumbers: 1})
            setIsValidNewPassword(isStrongPassword);
            if(!isStrongPassword) {
                errors.strongPassword = "Required";
            }
        }

        return errors;
    }

    const onSubmit = async(values, form) => {
        const { data } = cookies?.loginCookie

        try
        {
            let response = await axios.patch(`${process.env.REACT_APP_API_ENDPOINT_URL}${API_SUB_URL_USER}/update-password/${data?.id}`, values, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });
            if(response.data === null) {
                toast.error("Thay đổi mật khẩu không thành công!", {
                    position: "bottom-right"
                });
            } else {
                form.reset()
                displayConfirmAlert("Thay đổi mật khẩu thành công!", () => {
                    removeCookie("loginCookie", { path: "/" });
                    navigate("/login");
                })
            }
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }
    }

    return (
        <Form
            onSubmit={onSubmit}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                return (
                    <form onSubmit={handleSubmit}>
                        <Box>
                            <Header />
                            <Navbar />

                            <Flex justify="center">
                                <VStack borderRadius={20} boxShadow="lg" bg="white.100" width={{base: "100%", md: "50%", lg: "50%"}} px={8} py={4}>
                                    <Heading my="10px" size="lg">Thay đổi mật khẩu</Heading>

                                    <Divider />
                                    
                                    <Field name="currentPassword">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Mật khẩu hiện tại:</FormLabel>
                                                <InputGroup>
                                                    <Input {...input} type={showOldPassword ? 'text' : 'password'} placeholder=''
                                                        onCopy={(e) => {e.preventDefault()}} onPaste={(e) => {e.preventDefault()}}
                                                    />
        
                                                    <InputRightElement width="3rem">
                                                        <Button h="1.5rem" size="sm" onClick={handleOldPasswordVisibility}>
                                                            {showOldPassword ? <ViewOffIcon /> : <Icon as={ViewIcon} />}
                                                        </Button>
                                                    </InputRightElement>
                                                </InputGroup>
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="newPassword">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Mật khẩu mới:</FormLabel>
                                                <InputGroup>
                                                    <Input {...input} type={showNewPassword ? 'text' : 'password'} placeholder=''
                                                        onCopy={(e) => {e.preventDefault()}} onPaste={(e) => {e.preventDefault()}}
                                                    />

                                                    <InputRightElement width="3rem">
                                                        <Button h="1.5rem" size="sm" onClick={handleNewPasswordVisibility}>
                                                            {showNewPassword ? <ViewOffIcon /> : <Icon as={ViewIcon} />}
                                                        </Button>
                                                    </InputRightElement>
                                                </InputGroup>
                                                {
                                                    !isValidNewPassword &&
                                                    <FormLabel color="red">(Độ dài tối thiểu 8 ký tự bao gồm ít nhất 1 chữ in hoa, 1 chữ in thường và 1 ký tự số)</FormLabel>
                                                }
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="confirmNewPassword">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Xác nhận mật khẩu mới:</FormLabel>
                                                <InputGroup>
                                                    <Input {...input} type={showConfirmNewPassword ? 'text' : 'password'} 
                                                        placeholder='' onCopy={(e) => {e.preventDefault()}} onPaste={(e) => {e.preventDefault()}}/>

                                                    <InputRightElement width="3rem">
                                                        <Button h="1.5rem" size="sm" onClick={handleConfirmNewPasswordVisibility}>
                                                            {showConfirmNewPassword ? <ViewOffIcon /> : <Icon as={ViewIcon} />}
                                                        </Button>
                                                    </InputRightElement>
                                                </InputGroup>
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Button colorScheme='green' type='submit' size="lg" isDisabled={!valid} mt={4}>
                                        Thay đổi mật khẩu
                                    </Button>
                                </VStack>
                                <ToastContainer />
                            </Flex>
                        </Box>
                    </form>
                )
            }}
        />
    )
}

export default ChangePassword;